import { render } from "./Tickets.vue?vue&type=template&id=39f9d054&scoped=true"
import script from "./Tickets.vue?vue&type=script&lang=js"
export * from "./Tickets.vue?vue&type=script&lang=js"

import "./Tickets.vue?vue&type=style&index=0&id=39f9d054&lang=css"
import "./Tickets.vue?vue&type=style&index=1&id=39f9d054&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f9d054"]])

export default __exports__